import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { StatusItem } from "@ServerTypes/status/status.schema";

type TaskStatusMap = Record<string, StatusItem>;

const tasksStatusesSlice = createSlice({
  name: "tasksStatuses",
  initialState: {} as TaskStatusMap,
  reducers: {
    setTasksStatusesData: (_state: TaskStatusMap, action: PayloadAction<StatusItem[]>) =>
      action.payload.reduce(
        (prev: TaskStatusMap, curr: StatusItem) => ({ ...prev, [curr.id ?? curr._id ?? ""]: curr }),
        {},
      ),
  },
});

export const { setTasksStatusesData } = tasksStatusesSlice.actions;

export const tasksStatuses = tasksStatusesSlice.reducer;

export default tasksStatusesSlice.reducer;
